import * as Blockly from 'blockly/core';
// import { VmtFieldFlyoutText } from '../fields/VmtFlyout/VmtFlyoutEditField';
// import { createMinusField } from '../fields/field_minus';
// import { createPlusField } from '../fields/field_plus';
// import { getExtraBlockState } from '../fields/serialization_helper';
import './vmt_return';
import { Colors } from '../../const';

const REUSABLE_BRICK_COLOR = Colors.REUSABLE_BRICK_COLOR; //'#138D90';

/** Drag strategy that duplicates the block on drag. */
class DragToDupe {
    constructor(block) {
        this.block = block;
    }

    isMovable() {
        return true;
    }

    startDrag(e) {
        if (this.block.isShadow()) {
            // create a new parameter reference block
            const vmtReturnBlock = this.block.workspace.newBlock('vmt_return');
            vmtReturnBlock.data = JSON.stringify({ type: 'ret_val', parentBlockId: JSON.parse(this.block.data).parentBlockId });

            // Try to render the control - otherwise will throw an exception in headless mode
            if (typeof vmtReturnBlock.initSvg == "function") {
                vmtReturnBlock.initSvg();
                vmtReturnBlock.render();
            }
            this.copy = vmtReturnBlock;
            this.baseStrat = new Blockly.dragging.BlockDragStrategy(this.copy);
        }
        else {
            this.baseStrat = new Blockly.dragging.BlockDragStrategy(this.block);
        }
        this.baseStrat.startDrag(e);
    }

    drag(e) {
        this.baseStrat.drag(e);
    }

    endDrag(e) {
        this.baseStrat.endDrag(e);
    }

    revertDrag(e) {
        this.copy.dispose();
    }
}

/**
 * The return value block.
 * @type {Blockly.Block}
 */
Blockly.Blocks['vmt_return_decoration'] = {
    /**
     * Initializes the block.
     * @this {Blockly.BlockSvg}
     */
    init: function () {
        // this.appendValueInput('RET_VALUE')
        this.appendDummyInput('RET_VALUE')
            .setAlign(Blockly.inputs.Align.RIGHT)
            .appendField(new Blockly.FieldImage("media/images/reply_24dp_FFFFFF.svg", 20, 20));

        this.setOutput(true, null);
        this.setTooltip('Return from a reuable block');
        this.setHelpUrl('');
        this.setColour(REUSABLE_BRICK_COLOR);

        // setDragStrategy does not exist in headless mode
        if (typeof this.setDragStrategy == "function") {
            this.setDragStrategy(new DragToDupe(this)); // Attach drag strategy
        }
    },
}
